"use client";
import { useState } from "react";
import { Plus, Search } from "lucide-react";
import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { faq as data } from "@/lib/data/platform-security";

export function FAQ() {
  const [q, setQ] = useState("");
  const filtered = q
    ? data.items.filter((f) => f.q.toLowerCase().includes(q.toLowerCase()) || f.a.toLowerCase().includes(q.toLowerCase()))
    : data.items;
  return (
    <section id="faq" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-cyan)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-cyan)]" />
            {data.eyebrow}
          </span>
          <h2 className="mt-5">{data.title}</h2>
        </Reveal>
        <Reveal>
          <div className="max-w-2xl mx-auto mb-8">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[rgb(var(--fg-muted))]" />
              <input
                type="text"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search the FAQ…"
                className="w-full h-12 pl-11 pr-4 rounded-full glass text-sm bg-transparent focus:outline-none focus:ring-2 focus:ring-[var(--color-cyan)]/40"
              />
            </div>
          </div>
        </Reveal>
        <div className="max-w-3xl mx-auto space-y-3">
          {filtered.map((f) => (
            <details
              key={f.q}
              className="glass rounded-2xl group"
              style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-cyan) 12%, transparent)` }}
            >
              <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none hover:bg-[rgb(var(--border)/0.04)] transition-colors rounded-2xl">
                <span className="font-semibold text-sm text-left">{f.q}</span>
                <Plus className="h-4 w-4 shrink-0 text-[var(--color-cyan)] transition-transform group-open:rotate-45" />
              </summary>
              <div className="px-5 pb-5 -mt-1 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{f.a}</div>
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
}
